import React from 'react';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import { IconButton, Tooltip } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { useDispatch } from 'react-redux';

import { createChart } from '../../../../events';

const messages = defineMessages({
  ADD_CARD: {
    id: 'ADD_CARD',
    defaultMessage: 'Add card',
  },
  NEW_CHART: {
    id: 'NEW_CHART',
    defaultMessage: 'New Chart',
  },
});

function AddCardBtn({ intl }) {
  const dispatch = useDispatch();

  const addCard = () => {
    dispatch(createChart(null, null, null, null, intl, messages));
  };

  return (
    <Tooltip disableFocusListener title={<FormattedMessage {...messages.ADD_CARD} />}>
      <IconButton onClick={addCard}>
        <AddIcon />
      </IconButton>
    </Tooltip>
  );
}

export default injectIntl(AddCardBtn);
